import { createGlobalStyle } from "styled-components"
import { COLORS, TYPE } from "./globals"

export const GlobalStyles = createGlobalStyle`

* {
    -webkit-overflow-scrolling: touch;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    box-sizing: border-box;
    margin:0;
    padding:0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

html {
    font-size: 16px;
    color: ${COLORS.BLACK};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: ${TYPE.FONT_FAMILY};
}

body{
    padding:0;
    margin:0;
    overscroll-behavior: none;
    font-family:sans-serif;
}

.gatsby-plugin-transition-link-portal{
    pointer-events:none;
}

.tl-edges{
    overflow-x:visible;
}
`